"use client";
import { createGlobalStyle } from "styled-components";
const DefaultGlobalStyles = createGlobalStyle`
    p, ol, ul {
        margin: 0;
    }
`;
export {
  DefaultGlobalStyles
};
